import React from 'react';

import { Modal } from 'app-components';
import { FormattedMessage } from 'react-intl';

import CapitalizedButton from '../components/common/CapitalizedButton';
import { ModalContextType } from '../../../contexts/modalContext';
import useAppSelector from '@hooks/useAppSelector';

interface IModalProps extends ModalContextType {
    onContinue: () => void;
}

function PregnancyDisclaimerModal({ onContinue, closeModal }: IModalProps) {

    const { exchangeName, links } = useAppSelector(state => state.common.environment);

    const onClose = () => {
        closeModal('pregnancyDisclaimer');
    };

    const onContinueHandler = () => {
        closeModal('pregnancyDisclaimer');
        onContinue();
    };

    return (
        <Modal id="pregnancyDisclaimerModal">
            <Modal.Header
                id="PregnancyDisclaimerModalHeader"
                titleId="customGrouping.customGrouping"
                onHide={onClose}
            />
            <Modal.Body id="PregnancyDisclaimerModalBody">
                <FormattedMessage
                    id="customGrouping.pregnancyDisclaimer.content"
                    values={{ exchangeName, exchangePhone: links?.PHONE }}
                />
            </Modal.Body>
            <Modal.Controls>
                <CapitalizedButton
                    id="PregnancyDisclaimerModalCloseButton"
                    onClickHandler={onClose}
                    variant="secondary"
                    labelId="button.close"
                />
                <CapitalizedButton
                    id="PregnancyDisclaimerModalContinueButton"
                    onClickHandler={onContinueHandler}
                    variant="primary"
                    labelId="button.continue"
                    leftMargin={true}
                />
            </Modal.Controls>
        </Modal>
    );
}

export default PregnancyDisclaimerModal;
